// library to manage parallax and animations while scrolling

import simpleParallax from 'simple-parallax-js';

export const parallax = (function ($) {

    function init() {
        let marquee = document.querySelectorAll('.js-parallax-marquee');
        let marqueeInstance = new simpleParallax(marquee, {
            delay: .5,
            orientation: 'left',
            scale: 10,
            // maxTransition: 85,
            customWrapper: '.text-marquee-container',
            overflow: true
        });

        setTimeout(() => {
            marqueeInstance.refresh();
        },2000);

        let claimTitle = document.querySelectorAll('.js-parallax-claim-title');
        new simpleParallax(claimTitle, {
            delay: .5,
            orientation: 'right',
            scale: 2,
            maxTransition: 55, // more transition causes misaligned titles on mobile
            overflow: true
        });

    }

    return {
        init: init
    }

})(jQuery);
